module.exports = __webpack_public_path__ + "static/media/WA3F2020.98e14ca8.svg";